import { Routes, Route, Navigate } from "react-router-dom";
import StockInfo from "../pages/seller/products/StockInfo.jsx";
import AddCar from "../pages/admin/machine-modifications/AddCar.jsx"
import ManageCars from "../pages/admin/machine-modifications/ManageCars.jsx";
import ChangeLogs from "../pages/seller/machine-modifications/ChangeLogs.jsx";
import ArchivedCars from "../pages/seller/machine-modifications/ArchivedCars.jsx";
import AddSale from "../pages/seller/sale/AddSale.jsx";
import RefundSale from "../pages/seller/sale/RefundSale.jsx";
import RefundedSales from "../pages/seller/sale/RefundedSales.jsx";
import PriceDiscount from "../pages/admin/machine-modifications/PriceDiscount.jsx";
import NotFound from "../pages/shared/NotFound.jsx";
import { useLocation } from "react-router-dom";

export default function SellerRoutes() {

    const location = useLocation();
  

  return (
    <Routes>

      <Route index element={<Navigate to="add-sale" replace />} />
      <Route path="add-sale" element={<AddSale />} />
      <Route path="stock-info" element={<StockInfo />} />
      <Route path="add-car" element={<AddCar />} />
      <Route path="manage-cars" element={<ManageCars showDelete={false} />} />
      <Route path="change-logs" element={<ChangeLogs />} />
      <Route path="archived-cars" element={<ArchivedCars />} />
      <Route path="refund" element={<RefundSale  key={location.key} />} />
      <Route path="refunded-sales" element={<RefundedSales isAdmin={false} key={location.key} />} />
      <Route path="price-discount" element={<PriceDiscount />} />

      <Route path="*" element={<NotFound />} />

    </Routes>
  );
}


 